import { ITEM_UNAVAILABLE_MESSAGE } from "../lib/tenantLink.js";

export default function UnavailableLinkPage({ onOpenDashboard = null }) {
    return (
        <main role="alert" className="fixed inset-0 z-[10000] grid min-h-screen place-items-center bg-[color:var(--bg)] p-[24px] text-[color:var(--ink)]">
            <div className="w-full max-w-[520px] rounded-[2px] border border-[color:var(--line)] bg-[color:var(--control-bg)] px-[14px] py-[16px]">
                <div className="text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)]">Link unavailable</div>
                <p className="mt-[6px] text-[12px] leading-[1.5] text-[color:var(--muted)]">
                    {ITEM_UNAVAILABLE_MESSAGE}
                </p>
                {onOpenDashboard ? (
                    <button
                        type="button"
                        onClick={onOpenDashboard}
                        className="mt-[12px] cursor-pointer rounded-[2px] border border-[color:var(--line)] px-[8px] py-[3px] text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)] hover:border-[color:var(--ink)] hover:text-[color:var(--ink)] focus-visible:outline-2 focus-visible:outline-offset-2"
                    >
                        Open current organization
                    </button>
                ) : null}
            </div>
        </main>
    );
}
